import { render, staticRenderFns } from "./ChallengeDetailGallery.vue?vue&type=template&id=74765efe&scoped=true"
import script from "./ChallengeDetailGallery.vue?vue&type=script&lang=ts"
export * from "./ChallengeDetailGallery.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeDetailGallery.vue?vue&type=style&index=0&id=74765efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74765efe",
  null
  
)

export default component.exports